import { createReducer } from '@reduxjs/toolkit';

import { openModal, closeModal } from './actions';

import type { ModalsType } from './types';

const initialState: ModalsType = {
  modalType: undefined,
  params: undefined,
  isOpen: false
};

export const modalsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(openModal, (state, action) => {
      state.modalType = action.payload.modalType;
      state.params = action.payload.params;
      state.isOpen = true;
    })
    .addCase(closeModal, (state) => {
      state.modalType = undefined;
      state.params = undefined;
      state.isOpen = false;
    });
}); 